'use client';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { useHandleSearch } from '@/hooks/useHandleSearch';
import { useState, useEffect } from 'react';
import { useTranslations } from 'next-intl';

const HeroSearchBar = () => {
  const [inputText, setInputText] = useState('');
  const { handleSearch, isSearchLoading } = useHandleSearch();
  const [isMobile, setIsMobile] = useState(false);
  const t = useTranslations();

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 650);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputText(event.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && inputText.trim()) {
      handleSearch(inputText);
    }
  };

  return (
    <div className="relative mx-auto w-2xl max-md:w-md max-sm:w-xs">
      <div className="input input-bordered flex min-h-12 w-full items-center justify-between text-sm text-primary">
        <div className="flex w-full gap-1.5">
          <div>
            {isSearchLoading ? (
              <span className="loading loading-spinner h-4 w-4" />
            ) : (
              <FontAwesomeIcon
                icon={faSearch}
                className={`h-4 w-4 text-primary ${!inputText.trim() ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                onClick={() => handleSearch(inputText)}
              />
            )}
          </div>
          <input
            type="text"
            className="grow overflow-ellipsis"
            placeholder={isMobile ? 'Leistungsbeschreibung' : 'Beschreibung der Leistungen nach denen Sie suchen'}
            value={inputText}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
          />
        </div>
        <button
          onClick={() => handleSearch(inputText)}
          className="rounded-lg bg-accent py-1.5 text-center text-base font-semibold text-accent-content max-xs:w-24 xxs:w-28 xs:w-30"
        >
          {t('Button_Search')}
        </button>
      </div>
    </div>
  );
};

export default HeroSearchBar;
